// components/VerticalLayout/MobileBottomBar.js
import React from "react";
import { Album, Search, House, ShoppingBag, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import "./MobileBottomBar.css"; // Optional: for styles

import useIsMobile from "hooks/useIsMobile";

const MobileBottomBar = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    /*
    { icon: <Album />, path: "/myInfo/navigateThemes" },
    { icon: <Search />, path: "/myInfo/search" },
    */
    { icon: <ShoppingBag />, path: "/myInfo/storeMenu", label: "商店列表" },
    { icon: <House />, path: "/myInfo/infoFeed", label: "動態牆" },
    { icon: <User />, path: "/myInfo/profile", label: "用戶" },
  ];
  
  return (
    <div className="mobile-bottom-bar">
      {navItems.map((item, index) => (
        <div key={index} className="tooltip-container">
          <button
            key={index}
            className={`mobile-btn ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            {item.icon}
          </button>
          <span className="tooltip-text">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default MobileBottomBar;
